import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const requireModule = require.context('./modules', true, /routes\.js$/)
const routes = []
requireModule.keys().forEach(fileName => {
  routes.push(...requireModule(fileName).default)
})

routes.push({
  path: '/*',
  name: '404',
  component: () => import('./modules/home/views/Index'),
  meta: {
    auth: true
  }
})

const router = new Router({
  mode: 'history',
  routes: routes
})

/**
 * Check if user is logged in and can access such route
 *  if not, then redirect to Login
 */
router.beforeEach((to, from, next) => {
  if (to.meta.auth) {
    if (store.state.auth.tokens) {
      return next()
    } else {
      return next({ name: 'Login' })
    }
  }
  return next()
})

export default router
